import { Card, CardErrorBoundaryWithSpinfinity, Typography } from 'components';
import BodyContainer from './BodyContainer';
import CardReferences from './CardReferences';
import styles from './GutXAxisCard.module.css';
import OrganList from './OrganList';

export default function GutXAxisCard() {
  return (
    <CardErrorBoundaryWithSpinfinity cardName='GutXAxisCard'>
      <Card>
        <div className={styles.cardContainer}>
          <Typography variant='body-m'>
            Your gut microbiome connections
          </Typography>
          <Typography variant='body-xs' color='grey'>
            Dive deeper into a highlighted area to see what may be influencing
            it
          </Typography>
          <BodyContainer />
          <CardReferences />
          <OrganList />
        </div>
      </Card>
    </CardErrorBoundaryWithSpinfinity>
  );
}
